/**
 * sinper-currency-fix.js
 *
 * Easify Product Options (TPO) ile Beast Currency Converter (Doubly) arasındaki
 * senkronizasyon sorununu çözer.
 *
 * Sorun: Easify ölçü formülü fiyatı hesapladığında doubly-currency-try attribute'unu
 * güncellemez. Doubly bu attribute'u baz alarak döviz çevirimi yapar, bu yüzden
 * hesaplanan fiyat yerine eski (1 m²) fiyat dönüştürülür.
 *
 * Çözüm: MutationObserver ile .tpo_product_price elementini izle. Text değişince
 * ölçü input'larından ve ürün fiyatından doğrudan hesapla; attribute'u güncelle,
 * DoublyGlobalCurrency.convertAll() ile anında çevir, doublyChangeEvent() ile de tetikle.
 */
(function () {
  'use strict';

  /** .tpo_total-additional-price-wrapper elementini gizler (yeşil ek fiyat satırı). */
  (function hideAdditionalPriceBar() {
    var style = document.createElement('style');
    style.textContent = '.tpo_total-additional-price-wrapper { display: none !important; }';
    document.head.appendChild(style);
  })();

  /** Shopify variant birim fiyatını kuruş (cent) cinsinden döner. */
  function getUnitPriceCents() {
    return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product &&
      window.ShopifyAnalytics.meta.product.variants &&
      window.ShopifyAnalytics.meta.product.variants[0] &&
      window.ShopifyAnalytics.meta.product.variants[0].price) || 0;
  }

  /**
   * Ölçü input değerlerinden beklenen toplam fiyatı (kuruş) hesaplar.
   * Kural: min 1 m² uygulanır → MAX(1, en_m × boy_m) × birim_fiyat
   */
  function calculatePriceCents(widthInput, heightInput) {
    var w = parseFloat(widthInput.value) || 0;
    var h = parseFloat(heightInput.value) || 0;
    var unitCents = getUnitPriceCents();
    if (w <= 0 || h <= 0 || !unitCents) return 0;
    var areaSqm = (w / 1000) * (h / 1000);
    return Math.round(Math.max(1.0, areaSqm) * unitCents);
  }

  /** Seçili döviz kodunu döner (TRY varsayılan). */
  function getCurrentCurrency() {
    return (window.DoublyGlobalCurrency && window.DoublyGlobalCurrency.cookie &&
      window.DoublyGlobalCurrency.cookie.read()) || 'TRY';
  }

  /** Doubly'yi doğrudan (senkron) + retry mekanizmasıyla tetikler. */
  function triggerDoubly(currency) {
    // Doğrudan çağrı: doublyChangeEvent içindeki internal DoublyCurrency'nin
    // timing sorunlarını bypass eder.
    if (window.DoublyGlobalCurrency && typeof window.DoublyGlobalCurrency.convertAll === 'function') {
      window.DoublyGlobalCurrency.convertAll(currency);
    }
    // Retry mekanizması ve diğer elementler için doublyChangeEvent de ateşle.
    if (typeof window.doublyChangeEvent === 'function') {
      window.doublyChangeEvent();
    }
  }

  /**
   * doubly-currency-try attribute'unu günceller ve Doubly'yi yeniden tetikler.
   * Yalnızca TRY/TL formatındaki text değişimlerinde çalışır; Doubly'nin kendi
   * EUR/USD güncellemelerini (sonsuz döngü) önlemek için diğerleri atlanır.
   */
  function syncDoublyAttribute(priceEl, widthInput, heightInput) {
    var text = priceEl.textContent.trim();

    // Doubly EUR/USD vb.'ne çevirdiğinde bu text'i atla.
    // Sadece TRY/TL formatında Easify güncellemelerini işle.
    var isTRYFormat = text.indexOf('TRY') !== -1 || text.indexOf('TL') !== -1 || text.indexOf('₺') !== -1;
    if (!isTRYFormat) return;

    var cents = calculatePriceCents(widthInput, heightInput);
    if (!cents) return;

    var currentCurrency = getCurrentCurrency();
    var attrChanged = priceEl.getAttribute('doubly-currency-try') !== String(cents);

    // TRY modunda ve değer değişmemişse: yapacak bir şey yok.
    if (!attrChanged && currentCurrency === 'TRY') return;

    if (attrChanged) {
      // Doubly cached döviz attribute'larını temizle (doubly-currency-eur vb.)
      // Aksi halde Doubly cache'den eski değeri okur, yeni TRY'den hesaplamaz.
      var attrNames = Array.from(priceEl.attributes).map(function(a) { return a.name; });
      for (var i = 0; i < attrNames.length; i++) {
        if (attrNames[i].indexOf('doubly-currency-') === 0 && attrNames[i] !== 'doubly-currency-try') {
          priceEl.removeAttribute(attrNames[i]);
        }
      }
      priceEl.setAttribute('doubly-currency-try', String(cents));
    }

    // doubly-currency'yi TRY'ye çek ki Doubly "zaten çevrilmiş" diye atlamamasın.
    priceEl.setAttribute('doubly-currency', 'TRY');

    triggerDoubly(currentCurrency);
  }

  /** Attribute temizle + set et + Doubly tetikle (paylaşılan yardımcı). */
  function applyAndTrigger(priceEl, cents) {
    var attrNames = Array.from(priceEl.attributes).map(function(a) { return a.name; });
    for (var i = 0; i < attrNames.length; i++) {
      if (attrNames[i].indexOf('doubly-currency-') === 0 && attrNames[i] !== 'doubly-currency-try') {
        priceEl.removeAttribute(attrNames[i]);
      }
    }
    priceEl.setAttribute('doubly-currency-try', String(cents));
    priceEl.setAttribute('doubly-currency', 'TRY');
    triggerDoubly(getCurrentCurrency());
  }

  /** Observer'ı element'e bağlar ve ilk senkronizasyonu yapar. */
  function attachObserver(priceEl, widthInput, heightInput) {
    var observer = new MutationObserver(function () {
      syncDoublyAttribute(priceEl, widthInput, heightInput);
    });
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });

    // İlk yükleme: input değerlerine göre attr'u hemen düzelt
    var initCents = calculatePriceCents(widthInput, heightInput);
    if (initCents && priceEl.getAttribute('doubly-currency-try') !== String(initCents)) {
      applyAndTrigger(priceEl, initCents);
    }
  }

  /** Easify asenkron render ettiği için elementler hazır olana kadar bekler. */
  function init() {
    var priceEl = document.querySelector('.tpo_product_price');
    var widthInput = document.querySelector('input[id*="dimension-x"], input[name*="Dimension-Width"]');
    var heightInput = document.querySelector('input[id*="dimension-y"], input[name*="Dimension-Height"]');

    if (priceEl && widthInput && heightInput) {
      attachObserver(priceEl, widthInput, heightInput);
      return;
    }

    var attempts = 0;
    var interval = setInterval(function () {
      var pe = document.querySelector('.tpo_product_price');
      var wi = document.querySelector('input[id*="dimension-x"], input[name*="Dimension-Width"]');
      var hi = document.querySelector('input[id*="dimension-y"], input[name*="Dimension-Height"]');
      if ((pe && wi && hi) || ++attempts >= 40) {
        clearInterval(interval);
        if (pe && wi && hi) attachObserver(pe, wi, hi);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
